import { ORGANIZATION_DEFAULT_COUNTRY } from 'features/my-profile/become-fundraiser/context/becomeFundraiserUtils';
import { OrganizationFormData } from 'features/my-profile/become-fundraiser/form/components/add-organization/useAddOrganizationForm';
import { OrganizationDataDto, ProposedOrganizationDto } from 'services/user/userService.dto';

export const toOrganizationDataDto = (organization: OrganizationFormData): OrganizationDataDto => ({
  organizationName: organization.name,
  ein: organization.ein,
  addressLine1: organization.addressLine1,
  addressLine2: organization.addressLine2,
  city: organization.city,
  state: organization.state,
  zipCode: organization.zipCode,
  country: organization.country,
  fundraiserType: organization.isNonProfit ? 'PUBLIC' : 'FOR_PROFIT',
});

export const proposedToOrganizationFormData = (proposed: ProposedOrganizationDto): OrganizationFormData => ({
  name: proposed.organizationName,
  ein: proposed.ein,
  addressLine1: proposed.street,
  city: proposed.city,
  state: proposed.state,
  zipCode: proposed.zipCode,
  country: ORGANIZATION_DEFAULT_COUNTRY,
  isNonProfit: proposed.fundraiserType !== 'FOR_PROFIT',
});
